import store from '@/store'
import useAuth from '@/utils/useAuth'

let loadResourcesPromise = null

export default function useResources() {
  const { getMe, me } = useAuth()
  const loadResources = async () => {
    if (loadResourcesPromise) {
      return await loadResourcesPromise
    }

    const hasDataset =
      store.state.dataset && Object.keys(store.state.dataset).length > 0

    const tasks = []

    // Профиль уже мог быть загружен в bootstrap/guard.
    if (!me.value) {
      tasks.push(getMe())
    }

    if (!hasDataset) {
      tasks.push(
        store.dispatch('dataset/fetchDataset'),
        store.dispatch('schemas/getSchemas')
      )
    }

    if (!tasks.length) return

    store.commit('setStateProps', { prop: 'isLoading', value: true })

    loadResourcesPromise = Promise.all(tasks)
      .catch((error) => {
        throw error
      })
      .finally(() => {
        loadResourcesPromise = null
        store.commit('setStateProps', { prop: 'isLoading', value: false })
      })

    await loadResourcesPromise
  }

  return {
    loadResources,
  }
}
